import "./Solutions.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TransformationPillars from "./sections/TransformationPillars";
import IntelligentAutomationBenefits from "./sections/IntelligentAutomationBenefits";
import ConsultACloudExpert from "./sections/ConsultACloudExpert";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <MainNavigation />
      <TransformationPillars />
      <IntelligentAutomationBenefits />
      <ConsultACloudExpert />
      <Footer />
    </div>;
}